import register from 'ShopUiBundle/modules/app/registry';
import './style.scss';

// tslint:disable-next-line
register('catalog-faq', () => import(/* webpackMode: "lazy" */'./catalog-faq'));
